import React            from 'react'
import {
    useDomain
}                       from '../../../../../hooks/use';

const Delete = props => {
    console.log(props)
    const { blog }   = useDomain({ Blog: {} });
    const deleteBlog = () => {
        blog.removeBlog({
            id: props.data.blog_id
        });
        props.closeModal();
    }

    return (
        <div className="delete-container">
            <div className="delete-container-btn"><button className="okay" onClick={() => deleteBlog()}>Sil</button></div>
            <div className="delete-container-btn"><button className="exit" onClick={props.closeModal}>Vazgeç</button></div>
        </div>
    )
}

export default Delete
